/**
 * Ruta `/simulador`: cablea la vista con lo real — el cliente del Studio
 * (bearer de Entra del Studio, rutas `/studio/simulador/*`) y la cuenta de
 * Business Central con la app de Entra PROPIA del simulador (`msal.ts`).
 * Separado de la vista para que sus tests no carguen ninguno de los dos.
 */
import { useSearch } from "@tanstack/react-router";
import { studio } from "../../api/client";
import { cuentaSimulador } from "./msal";
import { Simulador } from "./Simulador";

export function SimuladorPage() {
  const search = useSearch({ strict: false }) as { estado?: string };
  return <Simulador api={studio.simulador} cuenta={cuentaSimulador} estado={search.estado} />;
}
